import React from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAdminDatasetsQuery } from '../../api/admin';
import { AppCard, AppCardTitle, AppPageHeader } from '../../components';
import { DatasetPermissionsTable } from '../../components/Admin';

export default function DatasetPermissionsPage() {
	const { dataset_id } = useParams<{ dataset_id: string }>();
	const navigate = useNavigate();
	const location = useLocation();
	const datasetId = parseInt(dataset_id!, 10);

	// Router state gives an instant title when arriving from the datasets table;
	// the (already cached) datasets list covers a direct load or refresh.
	const { datasetName: stateDatasetName, vendorName: stateVendorName } =
		(location.state as { datasetName?: string; vendorName?: string }) ?? {};
	const { data: datasets } = useAdminDatasetsQuery();
	const dataset = datasets?.find((d) => d.id === datasetId);

	const datasetName = dataset?.name ?? stateDatasetName ?? `Dataset #${datasetId}`;
	const vendorName = dataset?.vendor_name ?? stateVendorName;

	return (
		<>
			<AppPageHeader>
				<Stack direction="row" alignItems="center" spacing={2} mb={1}>
					<Button size="small" startIcon={<ArrowBackIcon />} onClick={() => navigate('/admin/datasets')}>
						Datasets
					</Button>
				</Stack>
				<Typography variant="h5">{datasetName}</Typography>
				<Typography variant="body2" color="text.secondary">
					{vendorName ? `${vendorName} · ` : ''}Active users with an active permission on this dataset
				</Typography>
			</AppPageHeader>
			<AppCard>
				<AppCardTitle variant="h6">Permissioned Users</AppCardTitle>
				<DatasetPermissionsTable datasetId={datasetId} />
			</AppCard>
		</>
	);
}
